import React from "react";

const ContentLegal = ({ data }) => {
  const renderContentItem = (contentItem, index) => {
    const heading = contentItem.content.find((el) => el.tag === "h3");
    const textContent = contentItem.content.filter((el) => el.tag !== "h3");

    return (
      <section
        className="content-legal-wrapper__articles__single-article"
        key={`section-${index}`}
      >
        {heading && <h3>{heading.content}</h3>}

        <div className="content-legal-wrapper__articles__text">
          {textContent.map((subItem, subIndex) => {
            if (subItem.tag === "ul") {
              const items = [];
              let i = 0;
              const flat = subItem.content;

              while (i < flat.length) {
                const current = flat[i];
                const isParent = current.trimEnd().endsWith(":");

                if (isParent) {
                  // Collect following non-parent strings as children
                  const children = [];
                  let j = i + 1;
                  while (j < flat.length && !flat[j].trimEnd().endsWith(":")) {
                    children.push(flat[j]);
                    j++;
                  }
                  items.push(
                    <li key={`li-${i}`}>
                      {current}
                      {children.length > 0 && (
                        <ul>
                          {children.map((child, ci) => (
                            <li key={`li-${i}-${ci}`}>{child}</li>
                          ))}
                        </ul>
                      )}
                    </li>,
                  );
                  i = j;
                } else {
                  items.push(<li key={`li-${i}`}>{current}</li>);
                  i++;
                }
              }

              return <ul key={`ul-${subIndex}`}>{items}</ul>;
            }
            return React.createElement(
              subItem.tag,
              { key: `p-${subIndex}` },
              subItem.content,
            );
          })}
        </div>
      </section>
    );
  };

  const sections = data.section?.content || [];

  return (
    <main className="content-legal-wrapper">
      {sections.map((sectionItem, index) =>
        renderContentItem(sectionItem, index),
      )}
    </main>
  );
};

export default ContentLegal;
